/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto. Keeping your custom
* Javascript in this file will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  function initReadMore() {
    document.querySelectorAll('.cl-abouttext--more').forEach(function(div) {
      div.innerHTML = div.innerHTML
        .replace(/<br>\s*<br>/gi, '</p><p>')
        .replace(/<br \/>\s*<br \/>/gi, '</p><p>');

      if (div.innerHTML.indexOf('<p>') === -1) {
        div.innerHTML = '<p>' + div.innerHTML + '</p>';
      }
    });

    document.querySelectorAll('.cl-introtext p').forEach(function(p) {
      var html = p.innerHTML.trim().toLowerCase();
      if (html === '' || html === '<br>' || html === '<br/>' || html === '<br />') {
        p.remove();
      }
    });

    document.querySelectorAll('[data-readmore]').forEach(function(block) {
      if (block.dataset.readmoreInit === 'true') return;
      block.dataset.readmoreInit = 'true';

      var btn = block.querySelector('[data-readmore-btn]');
      var content = block.querySelector('[data-readmore-content]');
      var labelOpen = block.querySelector('[data-readmore-label-open]');
      var labelClose = block.querySelector('[data-readmore-label-close]');

      if (!btn || !content) return;

      var isOpen = false;
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
      content.style.marginTop = '0px';
      content.style.overflow = 'hidden';

      function setOpen(open) {
        isOpen = open;

        if (isOpen) {
          block.classList.add('is-open');
          var openMargin = block.getAttribute('data-readmore-variant') === 'about' ? '8px' : '0px';
          content.style.marginTop = openMargin;
          content.style.opacity = '1';

          requestAnimationFrame(function() {
            content.style.maxHeight = content.scrollHeight + 'px';
          });

          btn.setAttribute('aria-expanded', 'true');
          if (labelOpen) labelOpen.style.display = 'none';
          if (labelClose) labelClose.style.display = 'flex';
        } else {
          block.classList.remove('is-open');
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          content.style.marginTop = '0px';

          btn.setAttribute('aria-expanded', 'false');
          if (labelOpen) labelOpen.style.display = 'flex';
          if (labelClose) labelClose.style.display = 'none';
        }
      }

      btn.addEventListener('click', function() {
        setOpen(!isOpen);
      });

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          if (isOpen) {
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        }, 200);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    initReadMore();
  }
  document.addEventListener('shopify:section:load', initReadMore);
})();